import { Helmet } from "react-helmet";
import Navbar from "../../../../components/Navbar/Navbar";
import WhatsAppWidget from "../../../../components/Navbar/Whatsapp";
import Banner from "../../../../components/body/projectPageComponents/Banner";
import Overview from "../../../../components/body/projectPageComponents/Overview";
import Pricing from "../../../../components/body/projectPageComponents/Pricing";
import Gallery from "../../../../components/body/projectPageComponents/Gallery";
import Location from "../../../../components/body/projectPageComponents/Location";
import Highlights from "../../../../components/body/projectPageComponents/Highlights";
import SiteVisitBanner from "../../../../components/body/projectPageComponents/SiteVisitBanner";
import FloorPlans from "../../../../components/body/projectPageComponents/FloorPlans";
import Amenities from "../../../../components/body/projectPageComponents/Amenities";
import Faq from "../../../../components/body/projectPageComponents/Faq";
import SimilarProject from "../../../../components/body/projectPageComponents/SimilarProject";

import { projectsGera } from "../../../../data/projects/Gera/data";

export const JoyOfTreetops = () => {
  const {
    gerajoyoftreetops: {
      form_data,
      whatsapp,
      bannerdata,
      overview,
      sitevisit,
      pricing,
      floor_plan,
      highlights,
      location,
      gallery,
      faq,
      similar
    }
  } = projectsGera;

  return (
    <>
      <Helmet>
        <title>Gera Joy of Tree Tops, Hinjewadi, Pune | Luxury Child-Centric Homes</title>

        <meta
          name="description"
          content="Explore Gera Joy of Tree Tops in Hinjewadi, Pune – premium child-centric residences with world-class amenities, smart home features, and a vibrant community. Invest in a future-ready home today!"
        />

        <meta
          name="keywords"
          content="Gera Joy Tree Tops, Gera Joy Tree Tops Hinjewadi, Gera Joy Tree Tops Pune, luxury apartments in Hinjewadi, child-centric homes Pune, Gera developments Pune, premium residences Hinjewadi, smart homes Pune, family-friendly homes Pune"
        />

        <link
          rel="canonical"
          href="https://propertystation.in/gera-joy-tree-tops-hinjewadi-pune"
        />

        <meta
          name="robots"
          content="index, follow"
        />

      </Helmet>

      <WhatsAppWidget whatsappdata={whatsapp} />
      <Navbar />

      <div className="mt-20">
        <Banner
          bannerDesktopImage={bannerdata.bannerDesktopImage}
          bannerMobileImage={bannerdata.bannerMobileImage}
          data={bannerdata.data}
          formData={form_data}
        />
        <Overview overviewData={overview} stripdata={overview.stripdata} />
        <SiteVisitBanner image={sitevisit.image} formData={form_data} />
        <Pricing pricingData={pricing} formData={form_data} />
        <FloorPlans floorPlans={floor_plan} formData={form_data} />
        <Highlights hightlightData={highlights} formData={form_data} />
        <Amenities />
        <Location location={location} />
        <Gallery galleryData={gallery} />
        <Faq faqdata={faq} />
        <SimilarProject Similarprojects={similar} />
      </div>
    </>
  );
};
